class ProductSizeHandler {
  constructor(wrapper) {
    this.wrapper = wrapper;
    this.productId = wrapper.getAttribute('data-product-id');
    this.sizeItems = this.wrapper.querySelectorAll('.size-item.size-available');
    this.bindEvents();
  }

  bindEvents() {
    this.sizeItems.forEach(sizeItem => {
      sizeItem.addEventListener('click', (e) => {
        e.preventDefault();
        if (sizeItem.classList.contains('loading')) return;
        this.handleSizeClick(sizeItem);
      });
    });
  }

  handleSizeClick(sizeItem) {
    sizeItem.classList.add('loading');
    const variantId = sizeItem.getAttribute('data-variant-id');
    const size = sizeItem.getAttribute('data-size');
    const productTitle = sizeItem.getAttribute('data-product-title');
    if (!variantId) return;
    this.addToCart(variantId, size, productTitle, sizeItem);
  }

  async addToCart(variantId, size, productTitle, sizeItem) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1,
            properties: { '_size_selected': size, '_product_title': productTitle }
          }]
        })
      });
      if (!response.ok) throw new Error('Network response was not ok');
      await response.json();
      document.dispatchEvent(new Event('apps:product-added-to-cart'));
      sizeItem.classList.remove('loading');
    } catch (error) {
      console.error('Error adding to cart:', error);
      sizeItem.classList.remove('loading');
      this.showError('Failed to add to cart. Please try again.');
    }
  }

  showError(message) {
    const div = document.createElement('div');
    div.textContent = message;
    div.style.cssText = 'position:fixed;top:20px;right:20px;background:#f44336;color:white;padding:15px 20px;border-radius:4px;z-index:9999;font-size:14px;box-shadow:0 4px 12px rgba(0,0,0,0.15)';
    document.body.appendChild(div);
    setTimeout(() => div.remove(), 3000);
  }
}

class ProductSizesContainer {
  constructor(container) {
    this.container = container;
    this.bindEvents();
  }

  bindEvents() {
    this.container.querySelectorAll('.product-sizes-wrapper').forEach(wrapper => {
      const swatches = wrapper.closest('.product-item')?.querySelectorAll('.product-item__details-wrapper .custom_bubbles .swatch__button_custom') || [];
      swatches.forEach(swatch => {
        swatch.addEventListener('click', () => {
          const clickedAttr = swatch.getAttribute('data-product-id');
          this.container.querySelectorAll('.product-sizes-wrapper').forEach(w => {
            w.classList.toggle('active-sizes', w.getAttribute('data-product-id') === clickedAttr);
          });
        });
      });
    });
  }
}

function initHandlers(container = document) {
  container.querySelectorAll('.product-sizes-wrapper:not([data-init])').forEach(wrapper => {
    new ProductSizeHandler(wrapper);
    wrapper.setAttribute('data-init', '1');
  });
  
  container.querySelectorAll('.products_size_all_varinat:not([data-init])').forEach(container => {
    new ProductSizesContainer(container);
    container.setAttribute('data-init', '1');
  });
}

document.addEventListener('DOMContentLoaded', () => initHandlers());

new MutationObserver(mutations => {
  if (mutations.some(m => Array.from(m.addedNodes).some(n => n.nodeType === 1 && (n.matches('.product-sizes-wrapper,.products_size_all_varinat') || n.querySelector('.product-sizes-wrapper,.products_size_all_varinat'))))) {
    setTimeout(() => initHandlers(), 50);
  }
}).observe(document.body, { childList: true, subtree: true });

window.reinitProductHandlers = (container) => initHandlers(container);